/**
 * Canonical API base URL for the app.
 * Must include /api (e.g. http://localhost:4000/api or https://api.landlordops.com/api).
 * Set in .env as REACT_APP_API_URL.
 *
 * Production builds must set REACT_APP_API_URL to the hosted **TypeScript** backend
 * (`landlordops-backend`), not the CRA `server.js` dev stub.
 */
const trimTrailingSlash = (url) => String(url || "").replace(/\/$/, "");

export function getApiUrl() {
  const raw = trimTrailingSlash(process.env.REACT_APP_API_URL || "");
  if (process.env.NODE_ENV === "production") {
    if (!raw) {
      console.error(
        "[LandlordOps] REACT_APP_API_URL is not set. This build cannot reach the TypeScript API."
      );
    } else if (/localhost|127\.0\.0\.1/i.test(raw)) {
      console.error(
        "[LandlordOps] REACT_APP_API_URL points at localhost in a production build. Use your hosted API (e.g. https://api.landlordops.com/api)."
      );
    }
  }
  return raw || "http://localhost:4000/api";
}

/**
 * Base URL for Stripe PaymentIntents, rent pay, Connect, etc.
 * In **production**, throws if REACT_APP_API_URL is missing or still localhost so
 * the app never silently talks to a dev server or empty host.
 */
export function getPaymentApiUrl() {
  const raw = trimTrailingSlash(process.env.REACT_APP_API_URL || "");
  if (process.env.NODE_ENV === "production") {
    if (!raw) {
      throw new Error(
        "Payments are disabled: set REACT_APP_API_URL to your production API base (must include /api), e.g. https://api.landlordops.com/api"
      );
    }
    if (/localhost|127\.0\.0\.1/i.test(raw)) {
      throw new Error(
        "Payments are disabled: REACT_APP_API_URL must not use localhost in production. Use the hosted TypeScript backend."
      );
    }
  }
  return raw || "http://localhost:4000/api";
}
